import { Chip as JoyChip, styled } from '@mui/joy';
import { useTheme } from '@mui/joy/styles';

import { TextEllipsis } from 'core/elements';
import { CustomColor, Size } from 'theme/enums';

interface ITreeChipProps {
  label: string;
  onClick: () => void;
  isSelected?: boolean;
  isMainSelected?: boolean;
}

const Chip = styled(JoyChip)({
  borderRadius: 6,
  padding: '8px 12px',
  whiteSpace: 'unset',
});

const useSlotProps = (
  label: string,
  onClick: () => void,
  isSelected: boolean,
  isMainSelected: boolean
) => {
  const theme = useTheme();

  let backgroundColor = theme.palette.neutral[200];
  let textColor = theme.palette.neutral[700];

  if (isMainSelected) {
    backgroundColor = theme.palette.neutral[700];
    textColor = theme.palette.common[CustomColor.WHITE];
  } else if (isSelected) {
    backgroundColor = theme.palette.neutral[500];
    textColor = theme.palette.common[CustomColor.WHITE];
  }

  return {
    action: {
      sx: {
        borderRadius: 6,
        backgroundColor,

        '&:hover': { backgroundColor },
      },
    },
    label: {
      content: label,
      onClick,
      lineHeight: 24,
      cursor: 'pointer',
      sx: {
        color: `${textColor} !important`,
        cursor: 'pointer',
        zIndex: 1,
      },
    },
  };
};

export const TreeChip = ({
  label,
  onClick,
  isSelected = false,
  isMainSelected = false,
}: ITreeChipProps) => {
  const slotProps = useSlotProps(label, onClick, isSelected, isMainSelected);

  return (
    <Chip
      size={Size.LG}
      onClick={onClick}
      slots={{
        label: TextEllipsis,
      }}
      slotProps={slotProps}
    />
  );
};
